import Vue from 'vue'
import Vuex from 'vuex'
import { Decrypt } from "@/util/secret";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(Decrypt(localStorage.getItem('userinfo') || '') || '{}') || {}
  },
  mutations: {
    setUser(state,value) {
      state.user = value
    },

    clearUser(state) {
      state.user = {}
    }
  },
  actions: {
  },
  modules: {
  }
})
